const devConfig = {
		BaseUrl: 'http://api.service.3ceasy.pisendev.com/api',//'http://api.service.3ceasy.dev.pinsunsoft.cn/api',// localhost:52147 api.service.3ceasy.dev.pinsunsoft.cn
    SettleCenterUrl: 'http://sch5.pisendev.com/AccountfundInfo/Index?mtoken=',
		SiteUrl: 'http://localhost:8080',
		AMapKey: 'b5d7534bddd2e469eec4a3353f29805f', // 高德地图key'
		AMapKeySecurityHost:''
}

const testConfig = {
    BaseUrl: 'http://api.service.3ceasy.pisendev.com/api',
    SettleCenterUrl: 'http://sch5.pisendev.com/AccountfundInfo/Index?mtoken=',
		SiteUrl: 'http://app.service.3ceasy.dev.pinsunsoft.cn',
		AMapKey: 'b5d7534bddd2e469eec4a3353f29805f', // 高德地图key'
		AMapKeySecurityHost: ''
}

const testConfig2 = {
    BaseUrl: 'http://apisvrapp2.ngrok.pisen.com.cn/api',
    SettleCenterUrl: 'http://sch5.pisendev.com/AccountfundInfo/Index?mtoken=',
		SiteUrl: 'http://appqjw2.ngrok.pisen.com.cn',
		AMapKey: 'b5d7534bddd2e469eec4a3353f29805f', // 高德地图key'
		AMapKeySecurityHost: ''
}

const productConfig = {
    BaseUrl: 'https://v3-sj-api.piseneasy.com/api',
    SettleCenterUrl: 'http://sch5.pisen.com.cn/AccountfundInfo/Index?mtoken=',
		SiteUrl: 'https://v3-sj-h5.piseneasy.com',
		AMapKey: '498fcf5c960fbd4f7ca174608ffb27fa', // 高德地图key'
		AMapKeySecurityHost: 'https://map.piseneasy.com/_AMapService1'
}

let Configs = {

}

if (process.env.NODE_ENV === 'production') {
    Configs = {
        ...Configs,
        ...productConfig
    }
} else if (process.env.NODE_ENV === 'devproduction') {
    Configs = {
        ...Configs,
        ...testConfig
    }

} else if (process.env.NODE_ENV === 'devproduction2') {
    Configs = {
        ...Configs,
        ...testConfig2
    }
} else {
    Configs = {
        ...Configs,
        ...devConfig
    }
}

export default Configs



// WEBPACK FOOTER //
// ./src/common/configs.js